import { DateRangeID, TimeRange } from '@fullstory/client-api';
import { Scope } from '@fullstory/proto/fs/api/search';
import { TimeInterval } from '@fullstory/proto/fs/api/segment';
import {
  DxCardFormat,
  DxChartType,
  FunnelMetricType,
  NoteSettings,
  NoteType,
} from '@fullstory/proto/fs/services/dx-objects';
import {
  Color,
  ConversionFunnelSettings,
  DimensionalitySettings,
  SegmentSettings,
  SingleNumberSettings,
  TrendFrequency,
  TrendSettings,
} from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import { int64 } from '@fullstory/proto/google/protobuf';
import { dateRangeById } from '@fullstory/search-model';
import { DEFAULT_DISPLAY } from '../savedMetrics';

const dateRangeID = DateRangeID.PastMonth;
const dateRange = dateRangeById[dateRangeID];
export const mockCardTimeRange: TimeRange = {
  Start: dateRange.range.Start,
  End: dateRange.range.End,
};
export const mockSingleNumberCardTimeRange = {
  startTime: dateRange.range.Start,
  endTime: dateRange.range.End,
};
export const mockCardSegment: SegmentSettings = {
  segmentId: 'everyone',
  segmentScope: Scope.SCOPE_SESSION,
};

export const cardDetails = {
  name: 'Card Name',
  description: 'This is a test card',
  metadata: null,
  isCanned: false,
  funnelMetricType: FunnelMetricType.FUNNEL_METRIC_TYPE_INVALID,
  format: DxCardFormat.FORMAT_INVALID,
  chartType: DxChartType.CHART_TYPE_INVALID,
};

export const mockSingleNumberSettings: SingleNumberSettings = {
  segmentId: ['everyone'],
  color: Color.COLOR_INVALID,
  conversionId: [''],
  computePast: false,
  displayAs: DEFAULT_DISPLAY,
  segment: mockCardSegment,
  timeRange: null,
  timeRangeComparison: null,
};

export const mockTrendSettings: TrendSettings = {
  segmentId: ['everyone'],
  color: Color.COLOR_INVALID,
  conversionId: [''],
  computePast: false,
  displayAs: DEFAULT_DISPLAY,
  segment: [mockCardSegment],
  timeRange: null,
  frequency: TrendFrequency.TREND_FREQUENCY_DAILY,
  dimensionSettings: null,
  timeRangeComparison: null,
};

export const mockDimensionalitySettings: DimensionalitySettings = {
  segmentId: ['everyone'],
  color: Color.COLOR_INVALID,
  computePast: false,
  displayAs: DEFAULT_DISPLAY,
  segment: mockCardSegment,
  timeRange: null,
  dimensionSettings: null,
  timeRangeComparison: null,
};

export const mockFunnelSettings: ConversionFunnelSettings = {
  segmentId: 'everyone',
  color: Color.COLOR_INVALID,
  segment: [mockCardSegment],
  conversionId: int64.zero,
  dateRange: null,
  dimensionSettings: null,
  dimensionApplication: null,
  timeRange: null,
  timeRangeComparison: null,
  timeInterval: TimeInterval.TIME_INTERVAL_INVALID,
  trendSteps: null,
};

export const mockNoteSettings: NoteSettings = {
  note: [
    {
      type: NoteType.NOTE_HEADER,
      content: 'Text Card',
    },
    {
      type: NoteType.NOTE_PARAGRAPH,
      content: "Here's some content.",
    },
    {
      type: NoteType.NOTE_HORIZONTAL_RULE,
      content: '',
    },
  ],
};
